/** Situações da entidade ClienteGrupoEconomico */
export interface ClienteGrupoEconomicoSituacao {
    id: number,
    nome: string;
    badge: string;
}

export const clienteGrupoEconomicoAtivo: ClienteGrupoEconomicoSituacao = {
    id: 1,
    nome: 'Ativo',
    badge: 'badge badge-success'
};
export const clienteGrupoEconomicoInativo: ClienteGrupoEconomicoSituacao = {
    id: 2,
    nome: 'Inativo',
    badge: 'badge badge-danger'
};

export const clienteGrupoEconomicoSituacoes: ClienteGrupoEconomicoSituacao[] = [
    clienteGrupoEconomicoAtivo,
    clienteGrupoEconomicoInativo
];
